import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import aiLogo from '@/assets/icons/aiLogo.png';
import styles from './Navbar.module.scss';
import LoginModal from './login-modal/LoginModal';
import { toggleLoginModal } from '@/reducers/login-pop';
import logoText from '@/assets/img/logoText.png';
import sxnulogoText from '@/assets/img/sxnu-logo.png';
import SimpleHOC from '@/libs/simpleHOC';
import { openBrowser } from '@/libs/utils';
import useSXNU from '@/hooks/useSXNU';
import IntegralDropdown from './components/IntegralDropdown';
import UserDropdown from './components/UserDropdown';
import LoginButton from './components/LoginButton';

const Navbar = (props) => {
  const uid = useSelector((state) => state.users.uid);
  const userData = useSelector((state) => state.users.data);

  const { isSXNU } = useSXNU();

  const dispatch = useDispatch();

  const handleLogIn = () => {
    dispatch(toggleLoginModal(true));
  };

  const getHomePath = () => {
    return isSXNU ? '/sxnu' : '/';
  };

  const handleIntegralClick = () => {
    openBrowser('https://www.yuque.com/zmrobo/aihub/wlciao5ec9i0p91f#wS5zz');
  };

  const { visibleNavbarItem, visibleNavbarInfo } = useSelector(
    (state) => state.ui,
  );
  // 抽离
  const navItems = [
    { to: getHomePath(), label: '首页' },
    { to: '/ailab', label: 'AI体验' },
    { to: '/course', label: '课程' },
    { to: '/embodiment', label: '具身智能' },
    {
      to: '/class',
      label: '班级管理',
      visible: userData?.authInfo?.vip === 2,
    },
    // { to: '/modelTrainNew/projects', label: '模型训练' },
    { to: '/libs', label: 'AI工具' },
    // { to: '/modelCommunity', label: '模型广场' },
    {
      to: '/sx-subject',
      label: 'AI+学科',
      visible: isSXNU,
    },
    {
      to: '/learning',
      label: '我的学习',
      visible: userData?.authInfo?.account_type === '学生',
    },
  ];

  return (
    <div className={classNames(styles.nvabarContainer, props.className)}>
      <div className={styles.nvabarClass}>
        <ul className={styles.leftLineClass}>
          {isSXNU ? (
            <div className={classNames(styles.flex, styles.logoContainerClass)}>
              <img src={sxnulogoText} style={{ height: '45px' }} />
            </div>
          ) : (
            <div className={classNames(styles.flex, styles.logoContainerClass)}>
              <img
                src={aiLogo}
                className={styles.logo}
                alt="LOGO"
                draggable={false}
              />
              <img className={styles.logoText} src={logoText}></img>
            </div>
          )}
          {visibleNavbarItem && (
            <div className={classNames(styles.flex, styles.linContainerClass)}>
              {navItems.map((item) => {
                if (item.visible === false) return null;
                return (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    className={(status) => {
                      return classNames(styles.lineClass, {
                        [styles.activeLink]: status.isActive,
                      });
                    }}
                  >
                    {item.label}
                    <div className={styles.line}></div>
                  </NavLink>
                );
              })}
            </div>
          )}
        </ul>

        {visibleNavbarInfo && (
          <div className={styles.rightLineClass}>
            <NavLink className={styles.eventButtonClass} to="/eventPromotion">
              <span>限时活动，领取积分</span>
            </NavLink>

            {uid && (
              <IntegralDropdown
                userData={userData}
                onGetMorePoints={handleIntegralClick}
              />
            )}

            {uid !== '' ? (
              <UserDropdown userData={userData} isSXNU={isSXNU} />
            ) : (
              <LoginButton onLogin={handleLogIn} />
            )}
          </div>
        )}
      </div>
      <LoginModal onClose={() => dispatch(toggleLoginModal(false))} />
    </div>
  );
};

export default SimpleHOC(Navbar);
